import React from "react";
import { ChatContactItemProps } from "./ChatContactItem.props";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import { P } from "common/P/P";

const ChatContactItem: React.FC<ChatContactItemProps> = ({
	name,
	positionName,
	active,
	cursor = true,
	onClick,
}) => {
	return (
		<div
			className={`grid gap-3 grid-cols-maxFr place-items-start px-3 py-1 rounded-md ${
				cursor && "cursor-pointer"
			} transition-all duration-300 ${active ? "bg-mainGradient" : ""}`}
			onClick={onClick}
		>
			<div className="p-2 rounded-full bg-grayOne place-self-center">
				<AvatarIcon />
			</div>
			<div className="grid">
				<P
					size="p2"
					type="medium"
					className={`${cursor && "cursor-pointer"} ${
						active ? "text-white" : "text-textColor"
					}`}
				>
					{name}
				</P>
				<P
					size="t1"
					type="regular"
					className={`${cursor && "cursor-pointer"} ${
						active ? "text-white" : "text-grayTwo"
					}`}
				>
					{positionName}
				</P>
			</div>
		</div>
	);
};

export default ChatContactItem;
